var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.employee)?_c('div',{staticClass:"mf-container mt-4"},[_c('h2',[_vm._v("En possession")]),_vm._v(" "),_c('articles',{attrs:{"articles":_vm.articles}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }